import styled from 'styled-components';

export const Wrapper = styled.div`
	margin: 30px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	gap: 30px;
`;
